import { action } from 'typesafe-actions';
import type { ReactNode } from 'react';

import { IChecklistTemplate } from 'APIPackage/AccountModule/interfaces/IChecklistTemplate';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';

import { CheckListsActionsEnum } from '../enums/CheckListsActionsEnum';
import { ICheckListForm } from '../interfaces/ICheckListForm';

export const checkListsInitPage = () => action(CheckListsActionsEnum.CHECK_LISTS_INIT_PAGE);
export const checkListsResetPage = () => action(CheckListsActionsEnum.CHECK_LISTS_RESET_PAGE);
export const checkListsGetTemplateList = () => action(CheckListsActionsEnum.CHECK_LISTS_GET_TEMPLATE_LIST);
export const checkListsGetTemplateListNextPage = () =>
  action(CheckListsActionsEnum.CHECK_LISTS_GET_TEMPLATE_LIST_NEXT_PAGE);
export const checkListsSetTemplateList = (
  templatesList: IChecklistTemplate[],
  page: number,
  pageCount: number,
  totalCount: number,
) =>
  action(CheckListsActionsEnum.CHECK_LISTS_SET_TEMPLATE_LIST, {
    templatesList,
    page,
    pageCount,
    totalCount,
  });
export const checkListsSetActiveTemplateId = (id: number | 'new') =>
  action(CheckListsActionsEnum.CHECK_LISTS_SET_ACTIVE_TEMPLATE_ID, { id });
export const checkListsUpdate = (values: ICheckListForm) =>
  action(CheckListsActionsEnum.CHECK_LISTS_UPDATE, { values });
export const checkListsDelete = (id: number) => action(CheckListsActionsEnum.CHECK_LISTS_DELETE, { id });
export const checkListsChangeDefault = (id?: number) =>
  action(CheckListsActionsEnum.CHECK_LISTS_CHANGE_DEFAULT, { id });
export const checkListsExportById = (
  id: number,
  format: ExportFormatsEnum,
  successRenderContent: (id: number) => ReactNode,
) => action(CheckListsActionsEnum.CHECK_LISTS_EXPORT_BY_ID, { id, format, successRenderContent });
export const checkListsFormSubmit = (
  values: ICheckListForm,
  initialValues: ICheckListForm,
  onSubmit: ((values: ICheckListForm) => void) | undefined,
  resetForm: (() => void) | undefined,
) => action(CheckListsActionsEnum.CHECK_LISTS_FORM_SUBMIT, { values, initialValues, onSubmit, resetForm });
export const checkListsFormQuestionDelete = (name: string, onUndo: () => void) =>
  action(CheckListsActionsEnum.CHECK_LISTS_FORM_QUESTION_DELETE, { name, onUndo });
